<template>
  <div>
    <header-component />
    <router-view></router-view>
    <footer-component />
  </div>
</template>

<script>
import headerComponent from "@/components/header.vue";
import footerComponent from "@/components/footer.vue";

export default {
  components: {
    headerComponent,
    footerComponent
  },
  beforeMount() {
    window.scrollTo(0, 0);
  }  
};
</script>

<style lang="scss" scoped>
.main_banner {
  width: 100%;
  background: url("../../assets/images/repayment/bg_ideaman.jpg");
  background-position: center;
  background-size: cover;
  position: relative;
  padding: 60px 0 100px;
  h1 {
    color: #fff;
    font-weight: 600;
  }
  p {
    color: #fff;
    margin-top: 20px;
  }
  .left_section {
    padding-left: 50px;
  }
}
.repay_cont {
  padding: 80px 0 60px;
  .right_side {
    position: relative;
    top: -120px;
    padding-right: 40px;
    .repay_form {
      padding: 30px;
      border-radius: 8px;
      background-color: white;
      box-shadow: 2.5px 4.33px 21.84px 2.16px rgba(0, 0, 0, 0.38);
      width: 100%;
      height: 500px;
      position: relative;
      h3 {
        font-weight: 600;
      }
      p {
        margin-top: 30px;
      }
      .btn-group {
        width: 100%;
        margin-bottom: 20px;
        .btn {
          height: 50px;
              background-color: #efcfd0;
              border: 0;
              color: #434343;
              font-weight: 600;
              box-shadow: none;
        }
        .btn:active, .btn:focus, .btn:active:focus, .btn.active {
          background: $base-color-red;
          color: #fff;
        }
      }
      form {
        .btn {
          width: 100%;
          margin-top: 20px;
          height: 50px;
          background: $base-color-red;
          border: 0;
          text-transform: uppercase;
          font-size: 16px;
        }
      }
    }
  }
  .dragonpay {
    h3 {
      font-weight: 600;
    }
    p {
      span {
        display: block;
        margin-top: 10px;
      }
    }
  }
}
@media (max-width: 768px) {
  .main_banner {
    background: url("../../assets/images/banner-blue.jpg");
    .left_section {
      padding-left: 0;
    }
  }
  .repay_cont {
    .right_side {
      padding-right: 0;
    }
    .dragonpay {
      position: relative;
      top: -60px;
    }
  }
}
</style>